<template>
  <div class="bb-soa"
  >
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-soa-title">
      <i class="icon-arrow-sort bb-soa-title__go-back" @click="goToClientCard()"/>
      <h2 class="bb-page-title">SoA</h2>
    </div>
    <div class="bb-soa-header">
      <div class="bb-soa-header-left">
        <div class="bb-soa-header-left__username"
             @click="goToClientCard()"
             v-if="clientInfo.firstName || clientInfo.lastName">
          {{clientInfo.firstName}} {{clientInfo.lastName}}
        </div>
        <FilterByDate :get-query="getSoa" position="right"/>
      </div>
      <div class="bb-soa-header-right">
        <div class="bb-soa-header-right-tax-credit-note"
             @mouseenter="showTooltip(true)"
             @mouseleave="showTooltip(false)"
             @click="openTaxCreditNote"
        >
          <RequestRange/>
          <transition name="bounce">
            <div v-if="isShowTooltip"
                 class="bb-soa-header-right-tax-credit-note-tooltip"
            >
              {{tollBarText}}
            </div>
          </transition>
        </div>
        <div class="bb-soa-header-right-search bb-search">
          <input class="bb-search__input"
                 type="text"
                 :readonly="openDoubleDelete"
                 @input="inputSearch"
                 placeholder="Search">
          <i class="icon-search bb-search__icon"/>
        </div>
        <div class="bb-soa-header-right-menu">
          <i class="icon-menu bb-soa-header-right-menu__icon" @click.stop="popupExport = true"/>
          <transition name="bounce">
            <div class="bb-soa-header-right-menu-popup"
                 v-if="popupExport"
                 v-click-outside="hidePopupExport">
              <span class="bb-soa-header-right-menu-popup__excel" @click.stop="openExport()">Export to Excel</span>
              <span class="bb-soa-header-right-menu-popup__zip" @click.stop="downloadZip()">Download files</span>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="bb-soa-body">
      <vue-perfect-scrollbar class="bb-soa-body-scroll" ref="bbSoaTable">
        <table class="bb-table bb-table_modal bb-soa-body-scroll__table">
          <thead class="bb-table-header">
          <tr class="bb-table-header-row">
            <th class="bb-table-header__item bb-table-header__item_hide"/>
            <th class="bb-table-header__item bb-table-header__item_soa-date">DATE</th>
            <th class="bb-table-header__item bb-table-header__item_description">DESCRIPTION</th>
            <th class="bb-table-header__item bb-table-header__item_soa-tax-invoice">TAX INV NO.</th>
            <th class="bb-table-header__item bb-table-header__item_outgoing bb-table-outgoing">OUTGOING, AED</th>
            <th class="bb-table-header__item bb-table-header__item_outgoing bb-table-outgoing">BREAKDOWN</th>
            <th class="bb-table-header__item bb-table-header__item_incoming bb-table-incoming">INCOMING, AED</th>
            <th class="bb-table-header__item bb-table-header__item_mode">MODE OF PAYMENT</th>
            <th class="bb-table-header__item bb-table-header__item_include-expenses">INCLUDE IN GENERAL EXPENSES</th>
            <th class="bb-table-header__item bb-table-header__item_balance">BALANCE, AED</th>
            <th class="bb-table-body__item bb-table-header__item_toolbar bb-table-header__item_toolbar_soa"/>
          </tr>
          </thead>
          <tbody class="bb-table-body">
          <transition name="fade-form">
            <RowSoa @hideEditSoa="hideEditSoa"
                    @createSoa="createSoa"
                    @editSoa="createSoa"
                    @setDate="setSoaDate"
                    @changeBalance="changeBalance"
                    @setDescription="setDescription"
                    @focusInput="focusInput"
                    @changeInput="changeInput"
                    @statusUpload="setDisabledSave"
                    @view="openFile"
                    @upload="uploadFile"
                    @remove="deleteFile"
                    @change="setInvoiceToSoa"
                    :client="clientInfo"
                    :list="expenseCategories"
                    :error="errorValidate"
                    :soa="soaEdit"
                    :expenseCategory="expenseCategories[0]"
                    :includesText="includesText"
                    :notIncludesText="notIncludesText"
                    :buttonText="'ADD'"
                    :checkedInvoice="checkedInvoice"
                    :soaList="soaList"
                    :refs="$refs"
                    :creatingSoa="creatingSoa"
                    :disableInput="disableInput"
                    :newSoa="newSoa"
                    :disable="disabledSaved"
                    v-if="newSoa"/>
          </transition>
          <RowSoa v-for="(soa, index) in filterSoa"
                  @openProforma="openProforma"
                  @createSoa="editSoa(soaEdit, soa.id, index)"
                  @setDescription="setDescription"
                  @openFile="openFile"
                  @setDate="setSoaDate"
                  @view="openFile"
                  @upload="uploadFile"
                  @remove="deleteFile"
                  @changeBalance="changeBalance"
                  @changeInput="changeInput"
                  @statusUpload="setDisabledSave"
                  @focusInput="focusInput"
                  @hideEditSoa="hideEditSoa"
                  @openEdit="openEditSoa"
                  @delete="deleteSoa"
                  @closeDelete="closeDelete"
                  @openBalance="openModalView"
                  @change="setInvoiceToSoa"
                  @openDelete="openDelete"
                  :key="index"
                  :index="index"
                  :editSoaIndex="editSoaIndex"
                  :creatingSoa="creatingSoa"
                  :checkedInvoice="checkedInvoice"
                  :includesText="includesText"
                  :notNewSoa="notNewSoa"
                  :notIncludesText="notIncludesText"
                  :client="clientInfo"
                  :list="expenseCategories"
                  :rowActive="rowActive"
                  :openDoubleDelete="openDoubleDelete"
                  :refs="$refs"
                  :newSoa="newSoa"
                  :soaList="soaList"
                  :disableInput="disableInput"
                  :disable="disabledSaved"
                  :buttonText="'SAVE'"
                  :expenseCategory="expenseCategories[0]"
                  :error="errorValidate"
                  :soa="editSoaIndex === index ? soaEdit : soa"
          />
          <tr class="bb-table-body-row bb-table-body-row__total bb-table-body-row__total_soa">
            <td/>
            <td class="bb-table-body__item bb-table-body__item_soa" colspan="3">
              Total
            </td>
            <td class="bb-table-body__item bb-table-body__item_soa_outgoing bb-table-body__item_soa" colspan="2">
              {{soaTotals ? convertNumber(soaTotals.totalOutgoing) : 0.00}}
            </td>
            <td class="bb-table-body__item bb-table-body__item_soa_incoming bb-table-body__item_soa">
              {{soaTotals ? convertNumber(soaTotals.totalIncoming) : 0.00}}
            </td>
            <td class="bb-table-body__item_soa"/>
            <td class="bb-table-body__item_soa"/>
            <td ref="totalBalance"
                class="bb-table-body__item bb-table-body__item_soa" colspan="2">
              <span @click="showBalanceWindow = !showBalanceWindow"
                    class="bb-table-body__item_cursor"
              >
                {{soaTotals ? convertNumber(soaTotals.totalBalanceAed) : 0.00}}
              </span>
              <transition name="bounce">
                <div class="bb-table-header-popup bb-table-header-popup_soa"
                     v-if="showBalanceWindow">
                  <TotalInvoice @openBalance="openBalance"
                                :soaList="soaList"
                                :soaTotals="soaTotals"/>
                </div>
              </transition>
            </td>
          </tr>
          </tbody>
        </table>
      </vue-perfect-scrollbar>
      <button class="bb-button-dashed" @click.stop="openNewSoa()">
        <i class="icon-cross"/>
        Add new
      </button>
    </div>
    <Pagination :data="soaList" :getQuery="getSoa" :limit="defLimit" class="bb-pagination"/>
    <transition name="fade" mode="out-in">
      <ExportExcel :columns="soaColumns"
                   v-if="openSettingExport"
                   :data="dataForExport"
                   file-name="soa"
                   :generateExcel="generateExcel"
                   @close="hideSettingExport"/>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="proformaOpen" @close="proformaOpen = false">
        <ProformaInvoice @close="proformaOpen = false"
                         :view-mode="true"
                         :editable-invoice="editableInvoice"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="issueProformaOpen" @close="closeIssueProforma">
        <template v-slot:buttons>
          <div class="bb-soa__send">
            <ButtonsEdit styles="accent"
                         @edit="proformaEvents.create()"
                         @delete="proformaEvents.cancel()"
                         :left-if="true"
                         no-pop-up="false"
                         btn-right-text="CANCEL"
                         btn-left-text="SAVE"
            />
          </div>
        </template>
        <ProformaInvoice ref="proformaInvoice"
                         @close="closeIssueProforma"
                         :issueProformaServices="issueProformaServices"
                         :invoiceIssueId="invoiceIssueId"
                         :issueProforma="true"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="taxInvOpen"
                   @close="taxInvOpen = false"
      >
        <BalanceByInvoices  @saveBalance="saveBalance"
                            @openProforma="openProformaCreditNote"
                            @openIssueProforma="openIssueProforma"
                            :soaInvoice="soaInvoice"/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="taxCreditNoteOpen"
                   @close="taxCreditNoteOpen = false"
      >
        <TaxCreditNote/>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="creditNoteProforma" @close="closeCreditNoteProforma">
        <template v-slot:buttons>
          <div class="bb-soa__send">
            <ButtonsEdit @edit="proformaEvents.create()"
                         @delete="proformaEvents.cancel()"
                         styles="accent"
                         no-pop-up="false"
                         :left-if="saveCreditNote"
                         btn-right-text="CANCEL"
                         btn-left-text="SAVE"/>
          </div>
        </template>
        <CreditNoteProforma ref="proformaCreditNote"
                            :invoiceId="invoiceId"
                            :editableSoaCreditNote="editableSoaCreditNote"
                            :view-mode="readOnlyCreditNote"
                            @updateCreditNotes="updateSoaTable"
                            @close="closeCreditNoteProforma"/>
      </ModalWindow>
    </transition>
    <transition name="bounce">
      <div class="bb-table-header-popup bb-table-header-popup_soa" v-if="showPopup">
        <span class="bb-table-header-popup__title">
          {{showPopup}}
        </span>
      </div>
    </transition>
    <transition name="routing-fade" appear>
      <SendingStatus v-if="errorMessage" :errorText="errorMessage" :close="hideError"/>
    </transition>
  </div>
</template>

<script>
import ContactsApi from '@/api/Contacts/api'
import SoaApi from '@/api/Soa/api'
import Toolbar from '@/components/Main/Toolbar/Toolbar'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import BalanceByInvoices from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/BalanceByInvoices'
import DataPicker from '@/components/Main/DataPicker/DataPicker'
import SoaCreditNote from '@/api/SoaCreditNote/api'
import moment from 'moment'
import convertNumber from '@/mixin/convertNumber'
import {get, debounce, cloneDeep, forEach, filter, sortBy, random} from 'lodash'
import DoubleDelete from '@/components/Main/DoubleDelete/DoubleDelete'
import SendingStatus from '@/components/Main/SendingStatus/SendingStatus'
import Pagination from '@/components/Main/Pagination/Pagination'
import TotalInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TotalInvoice'
import scrollTo from '@/mixin/scrollTo'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import FilterByDate from '@/components/Main/FilterByDate/FilterByDate'
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import ExpensesCategoryApi from '@/api/ExpenseCategories/api'
import Checkbox from '@/components/Main/Inputs/checkbox'
import TaxCreditNote from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TaxCreditNote'
import ExportExcel from '@/components/Main/ExportExcel/ExportExcel'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import CreditNoteProforma from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteProforma'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import InvoicesApi from '@/api/Invoce/api'
import RequestRange from '@/components/Main/Icons/RequestRange'
import Upload from '@/components/Main/Upload/Upload'
import UploadFileApi from '@/api/UploadFile/api'
import {passwordSoaDelete} from '@/constants/passwordForDelete'
import setFileData from '@/mixin/setFileData'
import getErrorMessage from '@/mixin/getErrorMessage'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'
import queryString from 'query-string'
import ContactSoaInvoices from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/ContactSoaInvoices'
import RowSoa from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/RowSoa'

export default {
  name: 'ContactSoa',
  mixins: [convertNumber, scrollTo, setFileData, getErrorMessage],
  components: {
    RowSoa,
    ContactSoaInvoices,
    Upload,
    Checkbox,
    CustomSelect,
    ButtonsEdit,
    LoaderFly,
    Toolbar,
    DataPicker,
    SendingStatus,
    DoubleDelete,
    TotalInvoice,
    Pagination,
    CreditNoteProforma,
    BalanceByInvoices,
    FilterByDate,
    RequestRange,
    TaxCreditNote,
    VuePerfectScrollbar,
    ExportExcel,
    ModalWindow,
    ProformaInvoice
  },
  data: function () {
    return {
      passwordSoaDelete: passwordSoaDelete,
      includesText: '3rd Party Fee (incl. in GE)',
      notIncludesText: 'BB Fee (excl. from GE)',
      showPopup: false,
      showBalanceWindow: false,
      tollBarText: 'Tax credit note',
      isShowTooltip: false,
      taxCreditNoteOpen: false,
      popupPosition: {
        left: 0,
        top: 0
      },
      dataForExport: {},
      soaColumns: [
        {
          title: 'DATE',
          property: 'date'
        },
        {
          title: 'DESCRIPTION',
          property: 'description'
        },
        {
          title: 'TAX INV NO.',
          property: 'taxInvoiceNumber'
        },
        {
          title: 'OUTGOING, AED',
          property: 'outgoing'
        },
        {
          title: 'INCOMING, AED',
          property: 'incoming'
        },
        {
          title: 'MODE OF PAYMENT',
          property: 'modeOfPayment'
        },
        {
          title: 'BALANCE, AED',
          property: 'balanceAed'
        }
      ],
      proformaEvents: {
        create: false,
        cancel: false
      },
      readyExport: false,
      startExport: true,
      loaderExport: false,
      openSettingExport: false,
      loaderRun: false,
      rowActive: false,
      disabledSaved: false,
      editSoaIndex: false,
      newSoa: false,
      notNewSoa: false,
      readOnlyCreditNote: false,
      issueProformaServices: [],
      saveCreditNote: false,
      deleteConfirmIndex: false,
      openDoubleDelete: false,
      popupExport: false,
      creditNote: {},
      defLimit: 100,
      soaInvoice: {},
      filterByDate: '',
      fullFilter: '',
      searchWords: '',
      soaEdit: {
        date: new Date(),
        outgoing: 0,
        incoming: 0,
        breakdown: 0,
        extra: 0,
        description: '',
        modeOfPayment: '',
        balanceAed: 0
      },
      invoiceId: '',
      filterByMisc: false,
      filterByPayment: false,
      filter: {},
      selectedColumns: [],
      filterSoa: [],
      errorValidate: false,
      proformaOpen: false,
      taxInvOpen: false,
      creatingSoa: false,
      creditNoteProforma: false,
      errorMessage: '',
      issueProformaOpen: false,
      newSoaValue: {},
      editableInvoice: {
        invoice: {}
      },
      invoiceIssueId: '',
      editableSoaCreditNote: '',
      crypt: true,
      files: {},
      disableInput: false,
      checkedInvoice: {},
      checkedService: {}
    }
  },
  computed: {
    expenseCategories: {
      get: function () {
        return this.$store.getters.expenseCategories
      },
      set: function (data) {
        this.$store.dispatch('setExpensesCategories', data)
      }
    },
    clientInfo: {
      get: function () {
        return this.$store.getters.clientInfo
      },
      set: function (data) {
        this.$store.dispatch('setClientInfo', data)
      }
    },
    soaList: {
      get: function () {
        return this.$store.getters.soaList
      },
      set: function (data) {
        this.$store.dispatch('setSoaList', data)
      }
    },
    soaTotals: {
      get: function () {
        return this.$store.getters.soaTotals
      },
      set: function (data) {
        this.$store.dispatch('setSoaTotals', data)
      }
    },
    getWithSearch: function () {
      return debounce(this.getSoa, 250)
    },
    isLoadingZip: {
      get: function () {
        return this.$store.getters.isLoadingZip
      },
      set: function (data) {
        this.$store.dispatch('setIsLoadingZip', data)
      }
    }
  },
  methods: {
    deleteFile (fileId, item) {
      if (!fileId) return
      item.uploadFile = ''
      UploadFileApi.deleteFile(fileId, this.crypt)
    },
    hideError () {
      this.errorMessage = ''
    },
    uploadFile (files, item) {
      const file = files[0]
      this.$set(item, 'uploadFile', file)
      if (!this.newSoa) this.$set(this.soaEdit, 'uploadFile', file)
      const fileDate = this.setFileData(file)
      UploadFileApi.createFile(fileDate, this.crypt)
        .then((resp) => {
          this.$set(item, 'uploadFile', resp.data)
          if (!this.newSoa) this.$set(this.soaEdit, 'uploadFile', resp.data)
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          this.fileUploadError = true
          console.error(err)
        })
    },
    openProformaCreditNote (id) {
      this.taxInvOpen = false
      this.creditNoteProforma = true
      this.readOnlyCreditNote = false
      this.saveCreditNote = true
      this.invoiceId = id
    },
    closeCreditNoteProforma () {
      this.editableSoaCreditNote = ''
      this.creditNoteProforma = false
    },
    showTooltip (val) {
      this.isShowTooltip = val
    },
    setDisabledSave (val) {
      this.disabledSaved = val
    },
    openTaxCreditNote () {
      this.taxCreditNoteOpen = true
    },
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file.id)
    },
    openIssueProforma (issueProformaServices, invoiceId) {
      this.taxInvOpen = false
      this.issueProformaOpen = true
      this.issueProformaServices = issueProformaServices
      this.invoiceIssueId = invoiceId
    },
    closeIssueProforma () {
      this.taxInvOpen = true
      this.issueProformaOpen = false
    },
    saveBalance (invoiceId) {
      this.loaderRun = true
      InvoicesApi.getSoaConsumed(invoiceId)
        .then((resp) => {
          this.loaderRun = false
          this.taxInvOpen = false
          this.getSoa({limit: this.defLimit})
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
          this.loaderRun = false
        })
    },
    getFile (id, item) {
      this.loaderRun = true
      UploadFileApi.getFile(id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
          this.loaderRun = false
        })
    },
    setDefaultSoa () {
      this.soaEdit = {
        date: new Date(),
        outgoing: 0,
        incoming: 0,
        breakdown: 0,
        extra: 0,
        description: '',
        modeOfPayment: '',
        excludeExpenses: false
      }
    },
    setDescription (description) {
      this.$set(this.soaEdit, 'description', description)
    },
    inputSearch (e) {
      const val = e.target.value
      const searchValue = val.toLowerCase().trim()
      this.getWithSearch({page: 1, limit: this.defLimit, search: searchValue})
    },
    setLinkToProforma (soa) {
      const regexp = /Inv BB-.+-\d+-\d+/gi
      const invNumbers = soa.description.match(regexp)
      if (invNumbers) {
        const invNo = `<span class="bb-soa-body__invoice-number">${invNumbers[0]}</span>`
        return soa.description.replace(regexp, invNo)
      }
      return soa.description
    },
    openProforma (event, soa) {
      if (event.target.id === 'invoice-number-one' || event.target.id === 'invoice-number-two') {
        const idInvoice = get(soa, 'invoice.id', false)
        if (!idInvoice) return
        this.loaderRun = true
        InvoicesApi.getInvoiceById(idInvoice)
          .then((resp) => {
            this.loaderRun = false
            this.proformaOpen = true
            this.editableInvoice.invoice = resp.data
          })
          .catch((err) => {
            this.errorMessage = this.getErrorMessage(err)
            this.loaderRun = false
            console.error(err)
          })
      }
      if (event.target.id === 'credit-note') {
        const idCreditNote = get(soa, 'creditNote', false)
        if (!idCreditNote) return
        this.loaderRun = true
        SoaCreditNote.getSoaCreditNotesById(idCreditNote)
          .then((resp) => {
            this.loaderRun = false
            this.editableSoaCreditNote = resp.data
            this.readOnlyCreditNote = true
            this.creditNoteProforma = true
            this.saveCreditNote = false
          })
          .catch((err) => {
            this.loaderRun = false
            console.error(err)
          })
      }
    },
    updateSoaTable () {
      this.getSoa({limit: this.defLimit})
    },
    openModalView (data) {
      this.soaInvoice = get(data, 'invoice', {})
      const soaInvoiceId = get(data, ['invoice', 'id'], '')
      const isMisc = get(data, 'isMisc', false)
      const isNoPaymentInvoice = get(data, 'isNoPaymentInvoice', false)
      const isAutoSoa = get(data, 'isAutoSoa', false)
      if (isMisc) {
        this.filterByMisc = !this.filterByMisc
        this.filter['isMisc='] = this.filterByMisc
        this.$router.replace({query: this.filter}).catch(err => err)
        this.getSoa({limit: this.defLimit})
      }
      if (isNoPaymentInvoice) {
        this.filterByPayment = !this.filterByPayment
        this.filter['isNoPaymentInvoice='] = this.filterByPayment
        this.$router.replace({query: this.filter}).catch(err => err)
        this.getSoa({limit: this.defLimit})
      }
      if (isAutoSoa) return
      if (!soaInvoiceId) return
      this.taxInvOpen = true
    },
    openBalance (invoice) {
      if (invoice.number === 'Bill to client' || invoice.number === 'Payment(no inv.)') return
      this.soaInvoice = invoice
      this.taxInvOpen = true
    },
    setActiveRow (index) {
      this.rowActive = index
      const widthTable = get(this.$refs, 'bbSoaTable.$el.offsetWidth', false)
      const afterElement = get(this.$refs, `bbRowAfter${index}`, [])
      if (widthTable && afterElement[0]) {
        afterElement[0].style.width = widthTable + 'px'
        afterElement[0].style.left = -4 + 'px'
      }
    },
    hideSettingExport () {
      this.openSettingExport = false
    },
    scrollUp () {
      const table = get(this.$refs, 'bbSoaTable.$el', false)
      if (table) {
        table.scrollTop = 0
      }
    },
    openNewSoa () {
      this.scrollUp()
      if (this.newSoaValue.date && !this.newSoaValue.balanceAed) {
        this.soaEdit = cloneDeep(this.newSoaValue)
        this.soaEdit.date = new Date()
      } else {
        this.setDefaultSoa()
      }
      this.newSoa = true
      this.editSoaIndex = false
      this.disableInput = false
    },
    checkboxVisibility (soa, index) {
      if (soa.isAutoSoa) return
      if (this.editSoaIndex === index) {
        return this.soaEdit.outgoing > 0
      } else {
        return soa.outgoing > 0
      }
    },
    checkboxChange (data, item) {
      item.excludeExpenses = !data
    },
    focusInput (type) {
      if (type === 'outgoing') {
        this.soaEdit.outgoing = this.soaEdit.outgoing ? this.soaEdit.outgoing : ''
      } else if (type === 'extra') {
        this.soaEdit.extra = this.soaEdit.extra ? this.soaEdit.extra : ''
      } else if (type === 'breakdown') {
        this.soaEdit.breakdown = this.soaEdit.breakdown ? this.soaEdit.breakdown : ''
      } else {
        this.soaEdit.incoming = this.soaEdit.incoming ? this.soaEdit.incoming : ''
      }
      this.errorValidate = false
    },
    validateNum (number) {
      if (typeof number === 'string') {
        number = +number.replace(/[^.\d;]/, '')
      }
      if (isNaN(number)) {
        return 0
      } else {
        return number
      }
    },
    displayModalView () {
      this.showPopup = true
    },
    hidePopup () {
      this.showPopup = false
    },
    displayPopup (e, type) {
      this.showPopup = type
      this.popupPosition = {
        left: `${e.clientX - 20}px`,
        top: `${e.clientY - 50}px`
      }
    },
    changeInput (type, value) {
      const invoiceService = get(this.soaEdit, 'invoiceService', [])
      const isMisc = get(this.soaEdit, 'isMisc', false)
      const isOverPaidInvoice = get(this.soaEdit, 'isOverPaidInvoice', false)
      const isNoPaymentInvoice = get(this.soaEdit, 'isNoPaymentInvoice', false)
      if (!this.soaEdit.outgoing) {
        this.soaEdit.outgoing = ''
      }
      if (!this.soaEdit.incoming) {
        this.soaEdit.incoming = ''
      }
      if (type === 'outgoing' || type === 'extra' || type === 'breakdown') {
        this.soaEdit.incoming = 0
      } else {
        this.soaEdit.extra = 0
        this.soaEdit.breakdown = 0
        this.soaEdit.outgoing = 0
      }
      if (type === 'extra' || type === 'breakdown') {
        this.disabledSaved = false
        this.$set(this.soaEdit, type, value)
        if (invoiceService.length === 0 && !isMisc && !isOverPaidInvoice) {
          this.disabledSaved = true
        }
        if (isNoPaymentInvoice) {
          this.disabledSaved = false
        }
        const extra = this.validateNum(this.soaEdit.extra) || 0
        const breakdown = this.validateNum(this.soaEdit.breakdown) || 0
        const sum = extra + breakdown
        const services = get(this.soaEdit, 'invoiceService', [])
        if (!services.length) this.$set(this.soaEdit, 'outgoing', sum)
      }
      if (type === 'incoming') {
        const isMisc = get(this.soaEdit, 'isMisc', false)
        if (!isNoPaymentInvoice || isMisc || invoiceService.length >= 1) {
          this.disabledSaved = true
        } else {
          this.disabledSaved = false
        }
        this.$set(this.soaEdit, type, value)
      }
    },
    setSoaDate (date) {
      this.soaEdit.date = date
    },
    openEditSoa ({item: soa, index}) {
      this.newSoa = false
      this.notNewSoa = true
      const editSoa = cloneDeep(soa)
      const {client, company, id, statusId, ...dataSoa} = editSoa
      this.soaEdit = dataSoa
      this.soaEdit.extra = editSoa.outgoing - editSoa.breakdown
      if (soa.invoice) this.soaEdit.invoice = soa.invoice
      if (soa.invoiceService) this.soaEdit.invoiceService = soa.invoiceService
      if (soa.uploadFile) this.soaEdit.uploadFile = soa.uploadFile
      if (soa.isNoPaymentInvoice || soa.isOverPaidInvoice) this.$set(this.soaEdit, 'isPayment', true)
      this.disabledSaved = false
      this.editSoaIndex = index
    },
    goToClientCard () {
      const id = get(this.clientInfo, 'id', '')
      if (!id) return
      this.$router.push({
        name: 'ContactCard',
        params: {id: id}
      })
    },
    clickRow (index) {
      if (this.editSoaIndex !== index) {
        this.hideEditSoa()
      }
    },
    setModeOfPayment (item) {
      this.soaEdit.modeOfPayment = item.id
    },
    hideEditSoa () {
      this.newSoa = false
      this.notNewSoa = false
      this.editSoaIndex = false
      if (!this.soaEdit.balanceAed) {
        this.newSoaValue = cloneDeep(this.soaEdit)
      }
      let content = false
      forEach(this.soaEdit, (item, key) => {
        if (item && key !== 'date') {
          content = true
        }
      })
      if (!content) {
        this.setDefaultSoa()
      }
    },
    openExport () {
      this.openSettingExport = true
      this.popupExport = false
      this.dataForExport = {
        client: this.$route.params.id,
        query: this.fullFilter
      }
    },
    downloadZip () {
      this.popupExport = false
      this.isLoadingZip = true
      const client = this.$route.params.id
      const date = this.fullFilter
      SoaApi.downloadZip({client, date})
        .then((resp) => {
          const dataStart = date.substr(5, 10)
          const dataEnd = date.substr(17, 20)
          saveAs(resp.data, `SOA by ${this.clientInfo.firstName} (${dataStart} - ${dataEnd}).zip`)
          this.isLoadingZip = false
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          this.isLoadingZip = false
          console.error(err)
        })
    },
    hidePopupExport () {
      this.popupExport = false
    },
    formatDate (date) {
      if (date) {
        return moment(date).format('DD-MMM-YY')
      } else {
        return ''
      }
    },
    getExpensesCategories () {
      ExpensesCategoryApi.getExpenseCategories()
        .then((resp) => {
          const modeOfPayment = filter(resp.data.expensesCategories, {type: 3})
          this.expenseCategories = sortBy(modeOfPayment, ['name'])
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    getSoa ({limit, page, filter, search}) {
      this.loaderRun = true
      if (filter) {
        this.filterByDate = `date=${filter}`
      }
      search ? this.searchWords = `&search=${search}` : this.searchWords = ''
      this.fullFilter = this.filterByDate + this.searchWords
      const query = {
        client: this.$route.params.id,
        limit: limit || this.defLimit,
        page: page,
        filter: this.fullFilter,
        isMiscFilter: this.filterByMisc,
        isPaymentFilter: this.filterByPayment
      }
      SoaApi.getSoa(query)
        .then((resp) => {
          this.loaderRun = false
          this.soaList = resp.data
          this.filterSoa = this.soaList.soas.filter(soa => soa)
          this.soaList.soas.forEach(item => { item.statusId = random(0, 3) })
          this.scrollUp()
          this.getSoaTotal()
        })
        .catch((err) => {
          this.loaderRun = false
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    getSoaTotal () {
      SoaApi.getSoaTotal(this.$route.params.id)
        .then((resp) => {
          this.soaTotals = resp.data[0]
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    delSoa (id, index) {
      this.deleteConfirmIndex = false
      SoaApi.delSoa(id)
        .then((resp) => {
          this.soaList.soas.splice(index, 1)
          this.getSoaTotal()
        })
        .catch((err) => {
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    async generateExcel (data) {
      const resp = await SoaApi.generateExcel(data)
      return resp
    },
    validateInputs () {
      this.soaEdit.outgoing = this.validateNum(this.soaEdit.outgoing)
      this.soaEdit.incoming = this.validateNum(this.soaEdit.incoming)
      this.soaEdit.breakdown = this.validateNum(this.soaEdit.breakdown)
      delete this.soaEdit.extra
      if (!this.soaEdit.outgoing && !this.soaEdit.incoming) {
        this.errorValidate = true
      } else {
        this.errorValidate = false
      }
    },
    checkOutgoing () {
      return this.validateNum(this.soaEdit.breakdown) > 0
    },
    changeBalance () {
      this.calculateBalance()
    },
    setInvoiceToSoa ({service = [], invoice = null, overPaid = null}) {
      if (invoice._id === 'misc' || invoice._id === 'payment') {
        this.$set(this.soaEdit, 'invoice', null)
      } else {
        this.$set(this.soaEdit, 'invoice', invoice)
      }
      if (!overPaid) {
        this.$set(this.soaEdit, 'isOverPaidInvoice', false)
      } else {
        this.$set(this.soaEdit, 'isOverPaidInvoice', overPaid._id === 'overpaid')
      }
      if (service.length > 0) {
        this.disableInput = true
      } else {
        this.disableInput = false
      }
      this.$set(this.soaEdit, 'invoiceService', service)
      this.$set(this.soaEdit, 'extra', 0)
      this.$set(this.soaEdit, 'isMisc', invoice._id === 'misc')
      this.$set(this.soaEdit, 'isNoPaymentInvoice', invoice._id === 'payment')
      if (this.soaEdit.outgoing > 0 || this.soaEdit.isNoPaymentInvoice) {
        this.disabledSaved = false
      }
      this.calculateBalance()
    },
    calculateBalance () {
      const services = get(this.soaEdit, 'invoiceService', [])
      const balance = services.reduce((sum, item) => {
        sum += +item.balance
        return sum
      }, 0)
      this.$set(this.soaEdit, 'breakdown', balance)
      this.$set(this.soaEdit, 'outgoing', balance)
      this.$set(this.soaEdit, 'incoming', 0)
    },
    setPayment (soa) {
      const isPayment = get(soa, 'isPayment', false)
      if (isPayment) {
        const incoming = get(soa, 'incoming', 0)
        const outgoing = get(soa, 'outgoing', 0)
        this.$set(soa, 'isNoPaymentInvoice', incoming > 0)
        this.$set(soa, 'isOverPaidInvoice', outgoing > 0)
        return
      }
      this.$set(soa, 'isNoPaymentInvoice', false)
      this.$set(soa, 'isOverPaidInvoice', false)
    },
    createSoa () {
      this.creatingSoa = true
      this.validateInputs()
      if (this.errorValidate || this.disabledSaved) return
      this.loaderRun = true
      this.soaEdit.client = this.clientInfo.id
      const invoiceId = get(this.soaEdit, ['invoice', '_id'], '')
      const services = get(this.soaEdit, 'invoiceService', [])
      const fileId = get(this.soaEdit, 'uploadFile.id', '')
      if (fileId) this.soaEdit.uploadFile = fileId
      if (invoiceId && services.length > 0) {
        const invoiceServices = services.map(item => {
          return {
            invoiceServiceId: item._id,
            balance: item.balance
          }
        })
        this.soaEdit.invoice = invoiceId
        this.soaEdit.invoiceService = invoiceServices
      }
      if (!this.soaEdit.breakdown) this.soaEdit.excludeExpenses = true
      this.soaEdit.modeOfPayment = get(this.soaEdit.modeOfPayment, 'id', this.soaEdit.modeOfPayment)
      SoaApi.createSoa(this.soaEdit)
        .then(() => {
          this.creatingSoa = false
          this.setDefaultSoa()
          this.getSoa({limit: this.defLimit})
          this.getSoaTotal()
          this.hideEditSoa('create')
        })
        .catch((err) => {
          this.creatingSoa = false
          this.loaderRun = false
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    editSoa (soa, id) {
      this.creatingSoa = true
      this.validateInputs()
      if (this.errorValidate || this.disabledSaved) return
      if (!soa.breakdown && !soa.outgoing) soa.excludeExpenses = true
      const invoiceId = get(soa, ['invoice', '_id'], '')
      const services = get(this.soaEdit, 'invoiceService', [])
      const fileId = get(soa, 'uploadFile.id', '')
      if (fileId) soa.uploadFile = fileId
      if (invoiceId && services.length > 0) {
        const invoiceServices = services.map(item => {
          return {
            invoiceServiceId: item._id,
            balance: item.balance
          }
        })
        soa.invoice = invoiceId
        soa.invoiceService = invoiceServices
      }
      soa.modeOfPayment = get(soa.modeOfPayment, 'id', soa.modeOfPayment)
      const excludeExpenses = get(this.soaList.soas.find((item) => item.id === id), 'excludeExpenses', true)
      if (soa.excludeExpenses === undefined) soa.excludeExpenses = excludeExpenses
      SoaApi.editSoa(soa, id)
        .then((resp) => {
          this.creatingSoa = false
          this.setDefaultSoa()
          this.getSoa({limit: this.defLimit})
          this.hideEditSoa()
        })
        .catch((err) => {
          this.creatingSoa = false
          this.$set(this.soaEdit, 'excludeExpenses', true)
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    openDelete () {
      this.openDoubleDelete = true
    },
    closeDelete (val) {
      this.openDoubleDelete = val
    },
    deleteSoa (id) {
      SoaApi.delSoa(id)
        .then((resp) => {
          this.openDoubleDelete = false
          this.deleteConfirmIndex = false
          this.getSoa({limit: this.defLimit})
          this.hideEditSoa()
        })
        .catch((err) => {
          this.openDoubleDelete = false
          this.deleteConfirmIndex = false
          this.errorMessage = this.getErrorMessage(err)
          console.error(err)
        })
    },
    async getClient () {
      try {
        const {data} = await ContactsApi.getContact(this.$route.params.id)
        this.clientInfo = data
      } catch (err) {
        this.errorMessage = this.getErrorMessage(err)
        console.error(err)
      }
    },
    calcHeightTable () {
      const tableScroll = get(this.$refs, 'bbSoaTable.$el', '')
      if (!tableScroll) return
      const tableScrollCoordinates = tableScroll.getBoundingClientRect()
      const heightButton = 49
      const maxHeight = document.body.clientHeight - tableScrollCoordinates.top - heightButton - 40
      const minHeight = 300
      const height = maxHeight < minHeight ? minHeight : maxHeight
      tableScroll.style.overflow = 'hidden'
      tableScroll.style.maxHeight = height + 'px'
    }
  },
  watch: {
    soaList () {
      this.calcHeightTable()
    }
  },
  updated () {
    if (this.$refs.proformaCreditNote) {
      this.proformaEvents.create = this.$refs.proformaCreditNote.createCreditNote
      this.proformaEvents.cancel = this.$refs.proformaCreditNote.cancelProforma
    }
    if (this.$refs.proformaInvoice) {
      this.proformaEvents.create = this.$refs.proformaInvoice.createInvoice
      this.proformaEvents.cancel = this.$refs.proformaInvoice.cancelProforma
    }
  },
  async beforeMount () {
    const filterSoa = JSON.parse(localStorage.getItem('filterSoa'))
    this.filter = filterSoa[`${this.clientInfo.id}`] || filterSoa
    window.addEventListener('unload', () => {
      const {location} = window
      const filterQuery = queryString.parse(location.search)
      localStorage.setItem('filterSoa', JSON.stringify(filterQuery))
    })
    this.$router.replace({query: this.filter}).catch(err => err)
    if (this.clientInfo.id !== this.$route.params.id) {
      await this.getClient()
    }
    this.getExpensesCategories()
    this.getSoaTotal()
    if (this.filter['isMisc=']) this.filterByMisc = this.filter['isMisc='] === 'true'
    if (this.filter['isNoPaymentInvoice=']) this.filterByPayment = this.filter['isNoPaymentInvoice='] === 'true'
    this.getSoa({limit: this.defLimit})
    const contactId = localStorage.getItem('taxCreditNotesOpen')
    if (contactId) this.taxCreditNoteOpen = true
  },
  beforeDestroy () {
    this.soaList = []
    localStorage.removeItem('taxCreditNotesOpen')
  },
  beforeRouteLeave (to, from, next) {
    const filterSoa = {
      [`${this.clientInfo.id}`]: from.query
    }
    localStorage.setItem('filterSoa', JSON.stringify(filterSoa))
    next()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-soa {
    @include global-font;
    min-width: 1400px;

    &__button {
      height: 30px;
      width: 57px;
    }

    &__send {
      position: relative;
      padding-bottom: 0;
      padding-top: 30px;
      margin-right: 8px;
      display: flex;
      justify-content: flex-end;
      box-shadow: 0 -10px 35px -15px rgba($color-silver, 0.4);
    }

    &-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      color: $color-accent;

      &__go-back {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 35px;
        height: 35px;
        font-size: 14px;
        cursor: pointer;
        transform: rotate(-90deg);
        border-radius: 50%;
        transition: .2s;
        margin-left: -10px;

        &:hover {
          color: $color-accent-hover;
        }
      }
    }

    &-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-left {
        display: flex;
        align-items: center;
        flex-grow: 1;

        &__username {
          margin-right: 27px;
          color: $color-accent;
          font-weight: 500;
          font-size: 15px;
          line-height: 18px;
          cursor: pointer;

          &:hover {
            color: $color-accent-hover;
          }
        }
      }

      &-right {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-grow: 1;

        &-tax-credit-note {
          position: relative;
          margin-right: 12px;
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgba($color-denim, 0.12);
          cursor: pointer;

          &-tooltip {
            position: absolute;
            right: 30%;
            top: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            padding: 4px 7px;
            background: rgba($color-black, 0.55);
            font-weight: 500;
            font-size: 11px;
            line-height: 13px;
            text-align: center;
            color: $color-white;
            border-radius: 3px;
            z-index: 20;
            pointer-events: none;

            &:before {
              content: '';
              position: absolute;
              right: 5px;
              top: -3px;
              display: block;
              width: 0;
              height: 0;
              border-left: 3px solid transparent;
              border-right: 3px solid transparent;
              border-bottom: 3px solid rgba($color-black, 0.55);
            }
          }
        }

        &-search {
          flex-grow: 1;
        }

        &-menu {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          position: relative;
          margin-left: 22px;
          margin-right: -10px;
          height: 42px;
          width: 42px;

          &__icon {
            transform: rotate(90deg);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            color: $color-accent;
            cursor: pointer;
            width: 100%;
            height: 100%;
          }

          &-popup {
            position: absolute;
            top: 34px;
            right: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            white-space: nowrap;
            background: $color-white;
            border-radius: 5px;
            box-shadow: 0 0 20px rgba($color-black, 0.05);
            font-weight: 300;
            font-size: 13px;
            line-height: 16px;
            cursor: pointer;
            z-index: 3;

            &:before {
              content: '';
              border: 4px solid transparent;
              border-bottom: 6px solid $color-white;
              position: absolute;
              right: 5px;
              top: -9px;
              width: 0;
            }

            &__excel {
              border-bottom: 1px solid $color-alabaster;
              padding: 14px 14px 12px;
              &:hover {
                transition: 0.3s;
                background-color: $color-wild-sand;
              }
            }

            &__zip {
              padding: 12px 14px 14px;

              &:hover {
                transition: 0.3s;
                background-color: $color-wild-sand;
              }
            }
          }
        }
      }
    }

    &-body {
      position: relative;
      border-radius: 5px;

      &__tax-invoice {
        width: 100%;
        white-space: nowrap;
        display: grid;
        grid-template-columns: 1fr 21px 15px;
      }

      &-breakdown {
        display: grid;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: 1fr;
        grid-template-rows: repeat(auto-fit, 30px);
        grid-gap: 10px;

        &__item {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        &__hint {
          position: absolute;
          font-size: 10px;
          color: $color-accent;
          top: 5px;
          right: -10px;
          cursor: pointer;

          &_number {
            top: auto;
          }
        }

        input {
          margin: auto;
        }
      }

      &__toolbar {
        display: flex;
      }

      &__file {
        margin-right: 10px;
      }

      .ps__rail-y {
        top: 51px;
        margin-top: 52px;
        height: calc(100% - 52px);
      }

      .ps__thumb-y {
        opacity: 1;
        background-color: $color-accent;
        z-index: 1;
      }

      &-scroll {
        overflow: hidden;
        max-height: 300px;
        position: relative;
        margin-top: 16px;
        width: 100%;
        box-shadow: 0 0 20px rgba($color-black, 0.05);
        border-radius: 5px;
        padding-left: 4px;
        margin-left: -4px;

        &__table {
          background-color: $color-white;
        }

        &-invoice {
          display: grid;
          grid-template-columns: auto 1fr;
          grid-gap: 10px;
          align-items: center;
        }

        &-tax {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4px 6px;
          margin-left: -15px;
          background: rgba($color-accent, 0.14);
          color: $color-accent;
          border-radius: 4px;
          font-size: 13px;
          white-space: nowrap;
        }
      }
    }
  }

</style>

<style lang="scss">
  @import "../../../../../../sass/variables";
  @import "../../../../../../sass/mixins";

  .bb-soa {
    &-body {
      &__invoice-number {
        color: $color-accent;
        cursor: pointer;

        &:hover {
          color: $color-accent-hover;
        }
      }

      &__credit-note-number {
        color: $color-accent;
        cursor: pointer;

        &:hover {
          color: $color-accent-hover;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/ContactSoa.vue